import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchSearchSuggestions } from "../../shared/global-search-au/actions";
import SearchRevamp from "./component";
import { clearAllFilters, updateAllSelectedFilterOptions, updateAppliedFilters, updateFilterOptionData, updateSelectedSuggestions, updateUrlOptions, updateListingType, setListingFBEvents, clearSelectedFilter } from "../filters/actions";
import { reloadCarList, resetCarList } from "../car-listing/actions";
import { fetchSearchResult } from "../home/actions";

const mapStateToProps = ({
    user: { secureToken, isLoggedIn, userGeoData },
    filters: {
        recentAppliedFilters,
        allFilters,
        selectedFilters,
        selectedSort,
        urlOptions,
        appliedFilters
    },
    cities: {
        selectedCity
    },
    carListing: {
        searchPageResult
    },
    homeCarList: {
        totalAvailableCars
    },
    config: {
        saleConfig
    },
    abExperiment: {
        webPriceDropDesktop
    }
}) => ({
    secureToken,
    searchPageResult,
    recentAppliedFilters,
    allFilters,
    selectedFilters,
    selectedSort,
    urlOptions,
    appliedFilters,
    isLoggedIn,
    selectedCity,
    totalAvailableCars,
    saleConfig,
    webPriceDropDesktop,
    userGeoData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchAutoSuggestionsConnect: fetchSearchSuggestions,
    updateFilterOptionDataConnect: updateFilterOptionData,
    fetchSearchResultConnect: fetchSearchResult,
    clearAllFiltersConnect: clearAllFilters,
    reloadCarListConnect: reloadCarList,
    updateUrlOptionsConnect: updateUrlOptions,
    updateSelectedSuggestionsConnect: updateSelectedSuggestions,
    updateAppliedFiltersConnect: updateAppliedFilters,
    updateListingTypeConnect: updateListingType,
    resetCarListConnect: resetCarList,
    updateAllSelectedFilterOptionsConnect: updateAllSelectedFilterOptions,
    setListingFBEventsConnect: setListingFBEvents,
    clearSelectedFilterConnect: clearSelectedFilter
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SearchRevamp);
